import { Injectable } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree,
} from '@angular/router';
import { AbcCore } from '@barthauer/abc/core';
import { catchErrorAndRethrow } from '@barthauer/abc/core/error-handling';
import { Observable } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { AuthenticationInterceptor } from '../interceptor/interceptor';
import { LoginComponentInfo } from '../login/login-component-info';
import { ProfileService } from './profile.service';
import { UserService } from './user.service';

@Injectable()
export class AuthenticationGuard {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private profileService: ProfileService,
    private abcCore: AbcCore
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.userService.isCurrentlyLoggedInOrAnonymousAllowed.pipe(
      concatMap(async (isAuthenticated) => {
        if (!isAuthenticated) {
          AuthenticationInterceptor.notifyUrl();
          return this.userService.createLoginPageUrlTree(this.router, this.route);
        } else {
          if (this.profileService.areProfilesSupported(this.router)) {
            if (!(await this.profileService.hasCurrentProfile.toPromise())) {
              const profileInfos = await this.profileService.getProfilesForCurrentUser().toPromise();
              AuthenticationInterceptor.notifyUrl();
              if (profileInfos && profileInfos.length === 1) {
                await this.profileService.setCurrentProfile(profileInfos[0]).toPromise();
                AuthenticationInterceptor.reload();
              } else {
                const forwardTo: string = null; // state.url;
                return this.profileService.createProfileSelectionPageUrlTree(this.router, this.route, forwardTo);
              }
            } else {
              this.abcCore.objectSpace.ensureInitialized();
              if (LoginComponentInfo.isCurrentPageLoginPage(this.router)) {
                AuthenticationInterceptor.reload();
              }
            }
          }
          //disableGetLanguageAPi
          // await this.userService.setDocumentElementLang();
        }
        AuthenticationInterceptor.resetUrl();
        return true;
      }),
      catchErrorAndRethrow((err) => this.abcCore.error.publish(err))
    );
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return true;
  }
}
